<template>
    <div class="c-m-search-profile">
        <h3 class="c-m-search-profile__heading">Valda regioner</h3>
        <ul class="c-m-search-profile__list c-m-search-profile__list--head">
            <li
                v-for="reg in metaRegions"
                class="c-m-search-profile__item"
                :key="`user-${user.Id}-search-profile-reg-${reg.Id}`"
            >
                <input
                    class="c-m-search-profile__input"
                    type="checkbox"
                    :name="`regions-search-profile-input-${reg.Id}`"
                    :id="`regions-search-profile-input-${reg.Id}`"
                    :checked="isSelectedAll(reg)"
                    :disabled="disableEverything"
                    @change="select($event, reg)"
                />
                <label class="c-m-search-profile__label" :for="`regions-search-profile-input-${reg.Id}`">
                    <span class="c-m-search-profile__checkbox">
                        <icon :icon="'check'" />
                    </span>
                    <span class="c-m-search-profile__text">{{reg.Name}}</span>
                </label>
                <span v-if="selectedSubsCount(reg) > 0" class="c-m-search-profile__count">
                    <icon icon="check_circle"></icon>
                    {{selectedSubsCount(reg)}}
                </span>
                <button
                    v-if="reg.Subcategories.length > 0"
                    class="c-m-search-profile__toggle"
                    :class="{'c-m-search-profile__toggle--toggled': isActive(reg.Id)}"
                    @click="toggleActive(reg.Id)"
                    aria-label="Växla mellan expanderat och minimerat läge"

                >
                    <icon
                        :icon="'expand_more'"
                    ></icon>
                </button>
                <ul
                    v-if="reg.Subcategories.length > 0 && isActive(reg.Id)"
                    class="c-m-search-profile__list c-m-search-profile__list--sub"
                >
                    <li
                        v-for="sub in reg.Subcategories"
                        class="c-m-search-profile__item"
                        :key="`user-${user.Id}-search-profile-sub-reg-${sub.Id}`"
                    >
                        <input
                            class="c-m-search-profile__input"
                            type="checkbox"
                            :name="`search-profile-input-sub-${sub.Id}`"
                            :id="`search-profile-input-sub-${sub.Id}`"
                            :checked="isSelected(sub.Id)"
                            :disabled="disableEverything"
                            @change="select($event, sub)"
                        />
                        <label class="c-m-search-profile__label" :for="`search-profile-input-sub-${sub.Id}`">
                            <span class="c-m-search-profile__checkbox">
                                <icon :icon="'check'" />
                            </span>
                            <span class="c-m-search-profile__text">{{sub.Name}}</span>
                        </label>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        components: {
            Icon
        },
        data() {
            return {
                activeId: null
            }
        },
        props: {
            disableEverything: {
                type: Boolean,
                default: false
            },
            metaRegions: {
                type: Array,
                default: () => ([])
            },
            regions: {
                type: Array,
                default: () => ([])
            },
            company: {
                type: Object
            },
            user: {
                type: Object
            }
        },
        methods: {
            isActive(Id) {
                return this.activeId === Id;
            },
            toggleActive(Id) {
                if (this.isActive(Id)) {
                    this.activeId = null;
                } else {
                    this.activeId = Id;
                }
            },
            select(event, reg) {
                const action = event.target.checked ? 'add' : 'delete'
                let payload = [];
                if (reg.Subcategories) {
                    payload = [...reg.Subcategories];
                } else {
                    payload = [reg];
                }
                this.$emit('updated', {payload, action});
            },
            isSelected(Id) {
                if (this.regions.find(reg => (reg.Id === Id))) {
                    return true;
                } else {
                    return false;
                }
            },
            isSelectedAll(reg) {
                return this.selectedSubsCount(reg) === reg.Subcategories.length
            },
            selectedSubsCount(reg) {
                const filtered = reg.Subcategories.filter(sub => (this.isSelected(sub.Id)));
                return filtered.length;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeSearchProfileRegions.vue